import { SVGProps } from 'react'

export const PhoneSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M375.168 480.832a381.504 381.504 0 0 0 165.632 169.6l55.232-56.832c6.4-7.232 16.768-9.6 25.6-6.4 27.968 9.6 58.368 14.4 89.6 14.4a25.6 25.6 0 0 1 24.768 25.6v89.6c0 14.4-11.2 25.6-24.768 25.6-236.032 0-427.2-196.032-427.2-438.4 0-14.4 11.2-25.6 24.768-25.6H396.8c13.568 0 24.832 11.2 24.832 25.6 0 32 4.736 63.168 14.336 92.8 2.432 8.832 0.832 19.2-6.4 26.368l-54.4 57.6zM512 128C299.968 128 128 300.032 128 512c0 212.032 172.032 384 384 384 212.032 0 384-172.032 384-384 0-212.032-172.032-384-384-384z m0-64c247.232 0 448 200.832 448 448 0 247.232-200.768 448-448 448-247.168 0-448-200.768-448-448 0-247.168 200.832-448 448-448z'
        fill='#1677FF'
      />
    </svg>
  )
}
